module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"onlinecity":"ONLINECITY.IO","about":"About","crew":"Crew","clients":"Clients","facts":"Facts","vacant_positions":"Vacant positions","our_blog":"Our blog","our_offices":"Our offices","passion":"Passion","contact_us":"Contact us"},"da":{"onlinecity":"ONLINECITY.IO","about":"Om","crew":"Holdet","clients":"Kunder","facts":"Fakta","vacant_positions":"Stillinger","our_blog":"Vores blog","our_offices":"Vores kontorer","passion":"Passion","contact_us":"Kontakt os"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/SectionNav.vue
// module id = 597
// module chunks = 1